import { HTMLAttributes } from 'react';
import { BaseModalProps, Modal } from '../../../components/mplat/Modal';
// import { ReactComponent as NewFolder } from '../../../assets/img/storage/actions-new-folder.svg';

interface StorageComponent extends HTMLAttributes<HTMLDivElement> {
    children?: React.ReactNode,
}

export function StorageFiltersMobile({ children, className, ...props }: StorageComponent) {
    return (
        <div className={`storage__filters-mobile ${className ? className : ''}`} {...props}>
            {children}
        </div>
    )
}

interface StorageFiltersMobileHeadingProps extends StorageComponent {
    label: string
}

export function StorageFiltersMobileGroup({ label, children, className, ...props }: StorageFiltersMobileHeadingProps) {
    return (
        <div className={`storage__filters-mobile-group ${className ? className : ''}`} {...props}>
            {label && <StorageFiltersMobileHeading label={label} />}
            {children}
        </div>
    )
}

export function StorageFiltersMobileHeading({ label }: StorageFiltersMobileHeadingProps) {
    return (
        <div className="storage__filters-mobile-heading">
            {label}
        </div>
    )
}

interface StorageFiltersModalProps extends BaseModalProps, HTMLAttributes<HTMLDivElement> {
    isOpen: boolean,
    onClose: () => void,
    minWidth?: number,
    maxWidth?: number,
    closeOnBack?: boolean,
    children?: React.ReactNode,
}

function StorageFiltersModal({ isOpen, onClose, ...props }: StorageFiltersModalProps) {
    const { children } = props;

    return (
        <Modal isOpen={isOpen} onClose={onClose} className="popup_storage popup_storage-filters" minWidth={150}>
            <StorageFiltersMobile>
                {children}
            </StorageFiltersMobile>
        </Modal>
    );
}

export default StorageFiltersModal;
